<template>
  <div>
    <div class="pagePopMask pFull" v-if="infoPop" @click="cancelImpEdit"></div>
    <div class="pagePop w1280 pCenter" v-if="infoPop">
      <div class="w">
        <div class="tit fnt_32">查看</div>
        <div>
          <a-table :columns="columns" :data-source="tableData" :pagination="false">
            <template slot="action" slot-scope="record">
              <a @click="handleView(record)">下载</a>
            </template>
          </a-table>
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="confirmImpEdit">{{ globalDataArray.siteTemplateLanguage.save }}</div>
          <div class="btn btn2" @click="cancelImpEdit">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" @click="cancelImpEdit"></div>
      </div>
    </div>
  </div>
</template>
<script>

import { updateMember } from '@/api/person/person'

import { defineComponent } from 'vue'
const columns = [
  // { title: '证书编号', dataIndex: 'certificateNumber', key: 'certificateNumber' },
  { title: '获奖人姓名', dataIndex: 'recipientName', key: 'recipientName' },
  { title: '编号', dataIndex: 'certificateNumber', key: 'certificateNumber' },
  // { title: '颁发机构', dataIndex: 'issuer', key: 'issuer' },
  // { title: '证书标题', dataIndex: 'title', key: 'title' },
  // { title: '证书描述', dataIndex: 'description', key: 'description' },
  // { title: 'pdf文件', dataIndex: 'pdfUrl', key: 'pdfUrl' },
  // { title: '预览图', dataIndex: 'previewImageUrl', key: 'previewImageUrl' },
  // { title: '获奖日期', dataIndex: 'awardDate', key: 'awardDate' },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

const data = []

export default {
  name: 'PersonCheck',
  props: {
    checkList: {
      type: Array,
      default: () => []
    },
    infoPop: {
      type: Boolean,
      default: false
    },
    person: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      studentInfo: {
        ...this.person
      },
      tableData: [],
      columns
    }
  },
  watch: {
    checkList: {
      immediate: true,
      handler(val) {
        this.tableData = val || []
      }
    }
  },
  created() {
    console.log('checkList数据：', this.checkList)
  },
  methods: {
    handleView(record) {
      // 处理下载逻辑
      console.log('handleView调用，record参数:', record)

      if (!record) {
        console.error('record参数为空')
        this.$message?.error('数据错误')
        return
      }

      const fileUrl = record.pdfUrl
      if (!fileUrl) {
        console.log('文件URL缺失')
        this.$message?.error('文件链接缺失')
        return
      }

      // 处理相对路径，确保是完整的URL
      let fullFileUrl = fileUrl
      if (!fileUrl.startsWith('http')) {
        // 如果是相对路径，拼接基础URL
        const baseUrl = this.STATIC_BASE_URL || window.location.origin
        fullFileUrl = baseUrl + (fileUrl.startsWith('/') ? '' : '/') + fileUrl
        console.log('🔗 URL处理:', {
          original: fileUrl,
          baseUrl: baseUrl,
          full: fullFileUrl
        })
      }

      try {
        console.log('🔍 开始分析下载参数:', {
          fileUrl: fileUrl,
          record: record,
          recipientName: record.recipientName,
          certificateNumber: record.certificateNumber
        })

        // 从URL中提取文件扩展名
        const urlParts = fullFileUrl.split('.')
        const fileExtension = urlParts[urlParts.length - 1].toLowerCase()

        console.log('📁 文件信息分析:', {
          originalUrl: fileUrl,
          fullUrl: fullFileUrl,
          urlParts: urlParts,
          fileExtension: fileExtension
        })

        // 设置下载文件名，保持原始扩展名
        const fileName = `${record.recipientName || '证书'}_${record.certificateNumber || 'certificate'}.${fileExtension}`

        console.log('📄 最终文件名:', fileName)

        // 使用XMLHttpRequest下载文件
        console.log('🚀 开始XMLHttpRequest下载...')
        const xhr = new XMLHttpRequest()
        xhr.open('GET', fullFileUrl, true) // 使用完整URL
        xhr.responseType = 'blob'

        xhr.onload = () => {
          if (xhr.status === 200) {
            try {
              const blob = xhr.response

              // 验证blob数据
              if (!blob || blob.size === 0) {
                console.error('❌ 下载的文件为空:', {
                  blob: blob,
                  size: blob?.size,
                  type: blob?.type
                })
                this.$message?.error('下载的文件为空，请重试')
                return
              }

              console.log('✅ 文件下载成功，开始处理:', {
                size: blob.size,
                type: blob.type,
                name: fileName,
                isBlob: blob instanceof Blob
              })

              // 创建下载链接
              const url = window.URL.createObjectURL(blob)
              console.log('🔗 创建的Blob URL:', url)

              const a = document.createElement('a')
              a.style.display = 'none'
              a.href = url
              a.download = fileName

              console.log('🎯 准备触发下载:', {
                href: a.href,
                download: a.download
              })

              // 添加到DOM并触发下载
              document.body.appendChild(a)

              // 尝试多种触发方式
              try {
                a.click()
                console.log('✅ 使用click()触发下载')
              } catch (e) {
                console.log('⚠️ click()失败，尝试其他方式:', e)
                // 备用触发方式
                const event = new MouseEvent('click', {
                  view: window,
                  bubbles: true,
                  cancelable: true
                })
                a.dispatchEvent(event)
                console.log('✅ 使用dispatchEvent触发下载')
              }

              // 延迟清理，确保下载完成
              setTimeout(() => {
                try {
                  document.body.removeChild(a)
                  window.URL.revokeObjectURL(url)
                  console.log('🧹 临时资源清理完成')
                } catch (e) {
                  console.warn('⚠️ 清理资源时出错:', e)
                }
              }, 2000) // 增加到2秒确保下载完成

              console.log('🎉 下载流程完成:', fileName)
              this.$message?.success('文件下载成功！')
            } catch (error) {
              console.error('处理下载文件时出错:', error)
              this.$message?.error('文件处理失败，请重试')
            }
          } else {
            console.error('下载失败，状态码:', xhr.status)
            this.$message?.error('下载失败，请稍后重试')
          }
        }

        xhr.onerror = () => {
          console.error('XMLHttpRequest下载失败')
          this.$message?.error('下载失败，网络错误')

          // 备用方案：使用fetch API
          console.log('使用备用方案：fetch API下载')
          this.downloadWithFetch(fileUrl, fileName)
        }

        xhr.onprogress = (e) => {
          if (e.lengthComputable) {
            const percentComplete = (e.loaded / e.total) * 100
            console.log('📊 下载进度:', {
              loaded: e.loaded,
              total: e.total,
              percent: percentComplete.toFixed(2) + '%'
            })
          } else {
            console.log('📊 下载进度:', {
              loaded: e.loaded,
              total: '未知',
              note: '无法计算总大小'
            })
          }
        }

        // 添加网络状态监控
        xhr.onreadystatechange = () => {
          console.log('🔄 请求状态变化:', {
            readyState: xhr.readyState,
            status: xhr.status,
            statusText: xhr.statusText
          })
        }

        console.log('📤 发送下载请求...')
        this.$message?.info('正在下载文件，请稍候...')
        xhr.send()
      } catch (error) {
        console.error('下载文件失败:', error)
        this.$message?.error('下载失败，请稍后重试')

        // 备用方案：在新窗口打开
        window.open(fullFileUrl, '_blank')
      }
    },
    // 备用下载方案：使用fetch API
    async downloadWithFetch(fileUrl, fileName) {
      try {
        // 处理相对路径，确保是完整的URL
        let fullFileUrl = fileUrl
        if (!fileUrl.startsWith('http')) {
          const baseUrl = this.STATIC_BASE_URL || window.location.origin
          fullFileUrl = baseUrl + (fileUrl.startsWith('/') ? '' : '/') + fileUrl
          console.log('🔗 fetch URL处理:', {
            original: fileUrl,
            baseUrl: baseUrl,
            full: fullFileUrl
          })
        }

        console.log('使用fetch API下载文件:', fullFileUrl)

        const response = await fetch(fullFileUrl)

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const blob = await response.blob()

        // 验证blob数据
        if (!blob || blob.size === 0) {
          throw new Error('下载的文件为空')
        }

        console.log('fetch下载文件信息:', {
          size: blob.size,
          type: blob.type,
          name: fileName
        })

        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = fileName

        document.body.appendChild(a)
        a.click()

        // 延迟清理
        setTimeout(() => {
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
          console.log('fetch下载完成，已清理临时资源')
        }, 1000)

        this.$message?.success('文件下载成功！')
      } catch (error) {
        console.error('fetch下载失败:', error)
        this.$message?.error('下载失败，请稍后重试')

        // 最终备用方案：直接在新窗口打开
        console.log('使用最终备用方案：新窗口打开')
        window.open(fullFileUrl, '_blank')
      }
    },
    cancelImpEdit() {
      this.tableData = []
      this.$emit('update:infoPop', false)
    },
    confirmImpEdit() {
      // 由于这是查看功能，直接调用取消方法关闭弹框
      this.cancelImpEdit()
    }
  }
}

</script>
